module.exports = __webpack_public_path__ + "img/card3.985c0e02.png";